import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography/Typography";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { userAction } from "../../actions/user.action";

const styles = (theme) => ({
  link: {
    "&&": {
      color: theme.palette.primary.main,
      textDecoration: "underline",
    },
  },
});

class AcknowledgeTerms extends React.Component {
  state = {
    acknowledgement: false,
  };

  acknowledgeTermsAndConditions = (e) => {
    e.preventDefault();
    this.props.dispatch(
      userAction.acknowledgeTerms(this.state.acknowledgement)
    );
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.checked });
  };

  render() {
    const { classes, user, tocUrl } = this.props;
    return (
      <Dialog
        open
        onClose={this.handleClose}
        aria-labelledby="acknowledgement-dialog-title"
        aria-describedby="acknowledgement-dialog-description"
      >
        <form onSubmit={this.acknowledgeTermsAndConditions}>
          <DialogTitle id="acknowledgement-dialog-title">
            Terms &amp; Conditions
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="acknowledgement-dialog-description">
              {
                tocUrl !== '' && 
                <Typography variant="body2" style={{ marginBottom: 10 }}>
                  View the updated terms &amp; conditions&nbsp;
                  <a
                    href={tocUrl}
                    target="_blank"
                    className={classes.link}
                  >
                    here
                  </a>.
                </Typography>
              } 
              <FormControlLabel
                control={
                  <Checkbox
                    name="acknowledgement"
                    onChange={this.handleInputChange}
                    checked={this.state.acknowledgement}
                    color="primary"
                    autoFocus
                  />
                }
                label="I acknowledge that I have read the important disclosures included on the
                website and that I have read and agree to be bound by the posted Terms &amp;
                Conditions (as amended from time to time)."
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={user.acknowledgingTerms || !this.state.acknowledgement}
            >
              Agree
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  tocUrl: state.app.tocUrl,
});

export default withStyles(styles)(connect(mapStateToProps)(AcknowledgeTerms));



// WEBPACK FOOTER //
// ./src/containers/AcknowledgeTerms/index.jsx